<template>
    <Multiselect id="ms_team" class="multiselect-locations multiselect-small" v-model="teamsSelected" mode="multiple"
        :close-on-select="false" :searchable="true" :create-option="false" :object="true" :options="teamsSelectable"
        :hideSelected="false" locale="de" fallback="en" @clear="clearedTeamMultiselect" placeholder="Team auswählen"
        @deselect="deselectedTeamMultiselect" @select="selectMultiselect"  />
</template>

<style>
.multiselect-locations {
    z-index: 120;
}
</style>


<script>

import Multiselect from '@vueform/multiselect';

import getTeams from "../composables/getTeams";

import { useTeamStore } from "../stores/TeamStore";

export default {

    setup() {
        const { teams, teams_error, loadTeams } = getTeams();
        loadTeams();

        let teamStore = useTeamStore();

        return { teams, teams_error, teamStore: teamStore, };

    },
    name: "MultiselectTeams",
    components: {
        Multiselect,
    },
    props: {

    },
    emits:['selectedteamsChanged'],
    data() {
        return {
            optionSelected: "",
            teamsSelected: [],
        }
    },
    mounted() {
        this.teamsSelected = this.teamStore.teams;
        let url = new URL(window.location.href);
        var params = [];
        params = url.searchParams.get('teams');
        var selectedTeamIds = [];
        this.teamsSelected.forEach(element => {
            const teamId =
                element.value
                ;
            if (teamId != []) {
                selectedTeamIds.push(teamId);
            }
        });
    },
    watch: {
        teamsSelected(newValue, oldValue) {
            this.teamStore.teams = this.teamsSelected;
            this.$emit('selectedteamsChanged',this.teamsSelected);
        }
    },
    computed: {
        teamsSelectable() {
            var items = [];
            if (this.teams) {
                this.teams.forEach(element => {
                    const team = {
                        value: element.id,
                        label: { en: element.name },
                    };
                    items.push(team);
                });
            }
            return items;
        },
    },
    methods: {
        clearedTeamMultiselect() {
            this.teamsSelected = []; 

        },
        deselectedTeamMultiselect() {
            if (this.teamsSelected.length == 0) {
                this.teamsSelected = [];
            }
        },
        selectMultiselect() {
            if (this.teamsSelected.length > 0) {
                const allOptionSelected = this.teamsSelected.find((teamSelected) => teamSelected.value == []);
                if (allOptionSelected != null) {
                    this.teamsSelected = this.teamsSelected.filter((teamSelected) => teamSelected.value != 9999);
                }
            }
        },
    }
}

</script>
<style scoped>
.multiselect-small {
    --ms-font-size: 0.8rem;
}
</style>>

